import React from 'react';
import TemplateTextField from './TemplateTextField';

const StepRiskProfile = ({ formData, updateFormData, nextStep, prevStep, riskProfiles, disabled }) => {
  const data = formData.riskProfile;

  const handleChange = (field, value) => {
    updateFormData('riskProfile', { [field]: value });
  };

  const selectProfile = (profile) => {
    handleChange('selectedProfile', profile.name);
    handleChange('description', profile.description);
  };

  return (
    <fieldset disabled={disabled}>
      <h4 className="soa-step-title">Risk Profile</h4>
      <p className="soa-step-subtitle">Assess the client's risk tolerance and select an appropriate risk profile</p>

      <div className="d-flex flex-column gap-2 mb-3">
        {riskProfiles.map((profile) => (
          <div
            key={profile.name}
            className={`soa-risk-card ${data.selectedProfile === profile.name ? 'selected' : ''}`}
            onClick={() => !disabled && selectProfile(profile)}
          >
            <div className="d-flex justify-content-between align-items-center">
              <span className="risk-name">{profile.name}</span>
              {data.selectedProfile === profile.name && (
                <i className="bi bi-check-circle-fill" style={{ color: 'var(--secondary-color)', fontSize: '1.1rem' }}></i>
              )}
            </div>
            <p className="risk-desc mb-0">{profile.description}</p>
          </div>
        ))}
      </div>

      {data.selectedProfile && (
        <>
          <div className="soa-section-banner">
            <i className="bi bi-shield-check"></i>
            Suitability Statement
          </div>

          <TemplateTextField
            fieldKey="riskProfile.suitabilityStatement"
            label="Why is this risk profile appropriate for the client?"
            value={data.suitabilityStatement}
            onChange={(val) => handleChange('suitabilityStatement', val)}
            placeholder="e.g. Based on the client's investment time horizon of 10+ years, capacity to absorb short-term losses, and desire for long-term capital growth, a Growth risk profile is appropriate..."
            rows={4}
            disabled={disabled}
          />
        </>
      )}

      <div className="soa-step-nav">
        <button className="btn btn-outline-secondary" onClick={prevStep}>
          <i className="bi bi-arrow-left me-1"></i>Back
        </button>
        <button className="btn btn-primary" onClick={nextStep}>
          Next: Recommended Strategy <i className="bi bi-arrow-right ms-1"></i>
        </button>
      </div>
    </fieldset>
  );
};

export default StepRiskProfile;
